/* eslint-disable react/no-danger */
import React, { useEffect } from 'react';
import { withAppContext } from '@ctsu/loader';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  Grid,
  ListItem,
  ListItemText
} from '@material-ui/core';
import { openSnackbar } from 'helpers/Notifier';
import { httpStatusEnum } from 'appconstants';
import { GetFromCtxValue, getEmptyValue } from 'helpers';
import molecules from 'ctsutheme/components/molecules';
import { withStyles } from '@material-ui/core/styles';
import { compose, withHandlers, withState } from 'recompose';
import HTMLEditor from 'components/HTMLEditor';
import { FormViewContent } from 'components/FormViewContent';
import atoms from 'ctsutheme/components/atoms';
import _ from 'lodash';
import { bindLogger } from 'helpers/BindLogger';
import { setOpenSetupCourierNotes } from 'actions/protocols/opensetup';
import { MUISelect, ValidatorForm } from 'components/FormHelpers/FormInputs';
import { openConfirmation } from 'helpers/Confirmation';
import { CTSUCardActions, GetEmptyValue } from 'components';
import { RenderEditable, RenderElement } from 'components/RenderHelpers';


const { Divider } = atoms;
const { CardContent } = molecules;

const styles = theme => ({
  root: {},
  textField: {
    // margin: 0,
    // padding: 0,
    // width: 120
  },
  leftIcon: {
    marginRight: theme.spacing(1)
  },
  iconSmall: {
    fontSize: 20
  },
  select: {
    padding: '5px 25px !important'
  },
  selectroot: {
    width: '100%'
  },
  actionContainer: {
    marginRight: 10
  }
});

const MiscUI = props => {
  const {
    classes,
    state,
    miscState,
    setState,
    setMiscState,
    miscellaneous,
    handleChange,
    handleNotes,
    clearMisc,
    onSaveCourierNotes,
    permission
  } = props;

  useEffect(() => {
    setMiscState({
      ...miscellaneous
    });
  }, [miscellaneous, setMiscState]);

  return (
    <ValidatorForm onSubmit={onSaveCourierNotes}>
      <CardContent>
        <Grid container className={classes.root} spacing={4}>
          <Grid item xs>
            <RenderEditable
              state={state}
              editable={permission}
              setState={setState}
              title="Miscellaneous"
            >
              <RenderElement access={state === false}>
                <>
                  <FormViewContent
                    primaryText="Express Courier"
                    secondaryText={
                      <GetEmptyValue value={miscellaneous && miscellaneous.collectCourierInfo} />
                    }
                  />
                  <Divider />
                  <FormViewContent
                    primaryText="Group Notes"
                    secondaryText={
                       miscellaneous
                      && miscellaneous.notes
                      && <div dangerouslySetInnerHTML={{ __html: miscellaneous.notes }} />
                    }
                  />
                </>
              </RenderElement>
              <RenderElement access={state === true}>
                <>
                  <FormViewContent
                    primaryText="Express Courier"
                    secondaryText={(
                      <MUISelect
                        className={classes.textField}
                        value={getEmptyValue(miscState && miscState.collectCourierInfo)}
                        name="collectCourierInfo"
                        onChange={handleChange}
                        title="Express Courier"
                      >
                        <ListItem button value="Express Courier">
                          <ListItemText primary="Express Courier" />
                        </ListItem>
                        <ListItem button value="Mandatory">
                          <ListItemText primary="Mandatory" />
                        </ListItem>
                        <ListItem button value="Not Required">
                          <ListItemText primary="Not Required" />
                        </ListItem>
                        <ListItem button value="Optional">
                          <ListItemText primary="Optional" />
                        </ListItem>
                      </MUISelect>
  )}
                  />
                  <FormViewContent
                    primaryText="Group Notes"
                    // secondaryText={}
                    data-id="grpNotes"
                  />
                  <div className="px-2">
                    <HTMLEditor
                      name="notes"
                      title="notes"
                      data={getEmptyValue(miscState && miscState.notes)}
                      onChange={handleNotes}
                    />
                  </div>
                  <Divider />
                  <CTSUCardActions
                    clearClick={clearMisc}
                    cancelClick={() => {
                      setState(!state);
                    }}
                    disabled={_.isEqual(miscState, miscellaneous)}
                  />
                </>
              </RenderElement>
            </RenderEditable>
          </Grid>
        </Grid>
      </CardContent>
    </ValidatorForm>
  );
};

const withConnectState = connect(
  (state, ownProps) => ({}),
  dispatch => bindActionCreators(
    {
      OnSetOpenSetupCourierNotes: setOpenSetupCourierNotes
    },
    dispatch
  )
);

export const Miscellaneous = withStyles(styles)(
  compose(
    withAppContext,
    withConnectState,
    withState('state', 'setState', false),
    withState('miscState', 'setMiscState', {}),
    withHandlers({
      clearMisc: props => event => {
        const { setMiscState, miscellaneous } = props;
        setMiscState({ ...miscellaneous });
      },
      handleChange: props => event => {
        const { miscState, setMiscState } = props;
        miscState[event.target.name] = event.target.value;
        setMiscState({ ...miscState });
      },
      handleNotes: props => event => {
        const { miscState, setMiscState } = props;
        miscState.notes = event;
        setMiscState({ ...miscState });
      },
      onSaveCourierNotes: props => event => {
        const {
          context,
          protocolId,
          setState,
          miscState,
          state,
          OnSetOpenSetupCourierNotes
        } = props;
        const saveMisc = () => {
          bindLogger(OnSetOpenSetupCourierNotes, context)(
            miscState,
            protocolId
          ).subscribe(resp => {
            if (resp.status === httpStatusEnum.SUCCESS) {
              openSnackbar({
                message: GetFromCtxValue(context, 'PROTOCOL_OPEN_SETUP_COURIER_SUCCESS'),
                variant: 'success',
                name: 'courier'
              });
              setState(!state);
            }
          });
        };
        openConfirmation({
          message: GetFromCtxValue(context, 'PROTOCOL_MISCELLANEOUS_COFIRM'),
          onAction: saveMisc,
          name: 'misc'
        });
      }
    })
  )(MiscUI)
);
